import type { CSSProperties, ReactNode } from "react";
import type { DataElScope } from "@/utils/dataEl";
import { CreferencePillContent } from "./CreferencePillContent";
import { CREFERENCE_ENTITY_TYPE } from "./CreferenceEntity";
import type { CreferenceInteraction } from "./creferenceInteractionTypes";
import type { CreferenceResolvedEntity } from "./useCreferenceResolvedEntity";

export interface CreferencePillReferenceProps {
  dataElScope: DataElScope;
  className?: string;
  disabled: boolean;
  interaction: CreferenceInteraction;
  leading: ReactNode;
  linkedLabelTextStyle: CSSProperties;
  resolvedEntity: CreferenceResolvedEntity;
  style?: CSSProperties;
}

export function CreferencePillReference({
  dataElScope,
  className,
  disabled,
  interaction,
  leading,
  linkedLabelTextStyle,
  resolvedEntity,
  style,
}: CreferencePillReferenceProps): ReactNode {
  return (
    <CreferencePillContent
      dataElScope={dataElScope}
      canClick={interaction.canClick}
      className={className}
      disabled={disabled}
      isHovered={interaction.isHovered}
      isLoading={resolvedEntity.isLoading}
      isMemberReference={isCreferenceMemberReference(resolvedEntity)}
      isUnresolved={resolvedEntity.isUnresolved}
      label={resolvedEntity.label}
      labelSuffix={resolvedEntity.labelSuffix}
      leading={leading}
      linkedLabelTextStyle={linkedLabelTextStyle}
      memberColor={resolvedEntity.member?.color ?? null}
      memberProviderIconPath={resolvedEntity.memberProviderIconPath}
      memberProviderSlug={resolvedEntity.memberProviderSlug}
      onClick={interaction.handleClick}
      onMouseEnter={() => interaction.setIsHovered(true)}
      onMouseLeave={() => interaction.setIsHovered(false)}
      rootRef={interaction.setHintAnchorElement}
      style={style}
    />
  );
}

function isCreferenceMemberReference(
  resolvedEntity: CreferenceResolvedEntity,
): boolean {
  return (
    resolvedEntity.effectiveEntityType === CREFERENCE_ENTITY_TYPE.MEMBER
    && Boolean(resolvedEntity.member)
  );
}
